import React from "react";
import styles from "./portfolioNav.css";
import { useState, useRef ,useEffect} from "react";
import { Link } from "react-router-dom";

const PortfolioNav = (props) => {
  const ul = useRef();
  const [open, setOpen] = useState("")
  const [activeElement, setActiveElement] = useState()

  const nav = useRef(null);
  const showNavBtn = useRef(null);

  const menuClickHandler = (event) => {
    if (open === "") {
      setOpen("open")
    } else {
      setOpen("")
    }
  }

  function changeImagePack(packname, e){

    props.getImagePack(packname);
    for(let li of ul.current.childNodes){
      if(li.classList.contains("active")){
        li.classList.remove("active");
      }
    }
    console.log(e.target.classList.contains("active"));
    if(!e.target.classList.contains("active")){
      e.target.classList.add("active")
      setActiveElement(e.target);
    }

    window.scrollTo(0,0);
  }

  // useEffect(() => {
  //   set
  
  // }, [])
  
  return (
    <nav className={open} ref={nav} id="side-nav">
      <ul ref={ul}>
        <li onClick={(e)=>{changeImagePack("Travel", e)}} className="active"><Link to>Travel</Link></li>
        <li onClick={(e)=>{changeImagePack("Wedding", e)}}><Link to>Wedding</Link></li>
        <li onClick={(e)=>{changeImagePack("Business", e)}}><Link to>Business</Link></li>
        <li onClick={(e)=>{changeImagePack("Baby Shoot", e)}}><Link  Link to>Baby</Link></li>
        <li onClick={(e)=>{changeImagePack("Family", e)}}><Link >Family</Link></li>
        <li onClick={(e)=>{changeImagePack("Maternity", e)}}><Link to>Maternity</Link></li>
        <li onClick={(e)=>{changeImagePack("Personal", e)}}><Link to>Personal</Link></li>
        <li onClick={(e)=>{changeImagePack("Pre-wedding", e)}}><Link to>Pre-Wedding</Link></li>
        <li onClick={(e)=>{changeImagePack("Post-wedding", e)}}><Link to>Post-Wedding</Link></li>
        <li onClick={(e)=>{changeImagePack("Other", e)}}><Link to>Other</Link></li>
      </ul>
      <span ref={showNavBtn} onClick={menuClickHandler} className={open} id="show-nav"><i class="material-icons">arrow_forward</i></span>
    </nav>
  )
}

export default PortfolioNav